/**
 * Canonical paths for `src/i18n/locales/{lang}/{meta,pages,app}/*.json` packs.
 */
import { existsSync } from "node:fs";
import { join } from "node:path";
import {
  interfaceLocaleFileForPath,
  SECTION_FILE_NAMES,
  META_DEFAULTS_FILE,
} from "./interface-locale-files.js";

function websiteRoot() {
  return typeof process !== "undefined" && typeof process.cwd === "function"
    ? process.cwd()
    : "";
}

/**
 * Absolute root for interface locale JSON on disk.
 * Uses cwd (not import.meta dirname) so Vite/Marko prerender bundles still read
 * `src/i18n/locales` — same strategy as `getDataJsonRoot()` in paths.js.
 */
export const I18N_LOCALES_ROOT = join(websiteRoot(), "src/i18n/locales");

/** @returns {boolean} */
export function interfaceLocaleRootExists() {
  return Boolean(I18N_LOCALES_ROOT) && existsSync(I18N_LOCALES_ROOT);
}

/**
 * @deprecated Use `interfaceLocaleAppPath` / `interfaceLocalePagePath` instead.
 * @param {string} lang
 * @param {string} slice legacy slice name (`ui` → `app`, `seo` → `meta` or `pages`)
 */
export function localeSlicePath(lang, slice) {
  const map = { ui: "app", seo: "meta" };
  return join(I18N_LOCALES_ROOT, lang, map[slice] || slice);
}

/** @param {string} lang @param {string} file base name without .json */
export function interfaceLocaleAppPath(lang, file) {
  return join(I18N_LOCALES_ROOT, lang, "app", `${file}.json`);
}

/** @param {string} lang @param {string} file base name without .json */
export function interfaceLocalePagePath(lang, file) {
  return join(I18N_LOCALES_ROOT, lang, "pages", `${file}.json`);
}

/** @param {string} lang @param {string} file base name without .json */
export function interfaceLocaleMetaPath(lang, file) {
  return join(I18N_LOCALES_ROOT, lang, "meta", `${file}.json`);
}

/** @deprecated Use `interfaceLocaleAppPath` */
export function interfaceLocaleUiPath(lang, file) {
  return interfaceLocaleAppPath(lang, file);
}

/** @deprecated Use `interfaceLocalePagePath` or `interfaceLocaleMetaPath` */
export function interfaceLocaleSeoPath(lang, file) {
  if (file === META_DEFAULTS_FILE) return interfaceLocaleMetaPath(lang, file);
  return interfaceLocalePagePath(lang, file);
}

export {
  interfaceLocaleFileForPath,
  SECTION_FILE_NAMES,
  SECTION_FILE_NAMES as SEO_CONTENT_SECTION_FILES,
  META_DEFAULTS_FILE,
};

export { relI18nLocalePath } from "./i18n-locale-paths-rel.js";
